module.exports = __webpack_public_path__ + "img/23.59dd8a75.jpg";